<template>
  <div class="flex flex-col h-screen bg-page">
    <div class="flex-1 overflow-hidden overflow-y-scroll">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="px-10 pt-10">
            <div
              v-for="item in list"
              :key="item.id"
              class="list-item"
              @click="$router.push({ name: 'repairDetail', query: { id: item.id } })"
            >
              <ListTitle :name="item.orderid" />
              <ListNewItem style="margin-top: 8px;" label="故障类型" :value="item.faulttype_name" :twoLine="true" />
              <ListNewItem label="工单内容" :value="item.cause" />
              <ListNewItem label="报单位置" :value="item.place_name" />
              <ListNewItem label="报单时间" :value="item.fault_time_name" />
              <div class="list-item-status" :class="getButtonClass(item.repairstate)">
                {{ getButtonText(item.repairstate, item.repairstate_name) }}
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script setup>
import { reactive, ref, computed } from "vue";
import { repairService } from "@/service";
import to from "await-to-js";
import { useStore } from "@/store";

const store = useStore();
const userInfo = computed(() => store.state.userInfo);

// 搜索表单数据
const formData = reactive({
  api_type: "3",
  page: 1,
  pagesize: 20,
  order: "6",
  fault_id: userInfo.value.id
});

const getButtonClass = repairstate => {
  const stateClassMap = {
    1: "yellow-status",
    2: "blue-status",
    3: "blue-status",
    4: "blue-status",
    5: "blue-status",
    7: "blue-status",
    8: "blue-status"
  };
  return stateClassMap[repairstate] || "grey-status";
};

const getButtonText = (repairstate, repairstate_name) => {
  const stateTextMap = {
    2: "已接单",
    3: "开始处理",
    4: "审核中",
    5: "待评价"
  };
  return stateTextMap[repairstate] || repairstate_name;
};

const list = ref([]);
const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false);
const onLoad = async () => {
  if (refreshing.value) {
    list.value = [];
    formData.page = 1;
    refreshing.value = false;
  }
  const [error, data] = await to(repairService.repairList(formData));
  if (error) {
    list.value = [];
    finished.value = true;
    return;
  }
  loading.value = false;
  list.value.push(...data.data.data);
  formData.page++;
  if (list.value.length >= data.data.total) {
    finished.value = true;
  }
};
const onRefresh = () => {
  refreshing.value = true;
  finished.value = false;
  loading.value = true;
  onLoad();
};
</script>
